import _classCallCheck from "/opt/store-locator/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/store-locator/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/store-locator/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/store-locator/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/opt/store-locator/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/store-locator/node_modules/@babel/runtime/helpers/esm/inherits";
import "core-js/modules/es6.date.now";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.object.define-property";
import t from "react";

function e(t, e, s) {
  return e in t ? Object.defineProperty(t, e, {
    value: s,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = s, t;
}

var s = "undefined" != typeof window ? window : global,
    a = s.requestAnimationFrame ? s.requestAnimationFrame.bind(s) : function (t) {
  return s.setTimeout(t, 16);
},
    i = s.cancelAnimationFrame ? s.cancelAnimationFrame.bind(s) : s.clearInterval.bind(s),
    o = Object.freeze({
  EXPANDED: "EXPANDED",
  COLLAPSED: "COLLAPSED",
  EXPANDING: "EXPANDING",
  COLLAPSING: "COLLAPSING"
}),
    l = function l(t) {
  return t < .5 ? 4 * t * t * t : .5 * Math.pow(2 * t - 2, 3) + 1;
},
    h = function h(t) {
  return t === o.EXPANDING || t === o.COLLAPSING;
},
    r = function r(_ref) {
  var t = _ref.value,
      _ref$max = _ref.max,
      e = _ref$max === void 0 ? 1 : _ref$max,
      _ref$min = _ref.min,
      s = _ref$min === void 0 ? 0 : _ref$min;
  return t > e ? e : t < s ? s : t;
},
    p = function p() {
  return Date.now();
},
    n = function n(t) {
  return Math.max(0, parseInt(+t, 10) || 0);
},
    g = function g(_ref2) {
  var t = _ref2.next,
      e = _ref2.prev;
  var s = Math.abs(t - e);
  var a = t;
  return s > .15 && (t > e ? a -= .75 * s : a += .75 * s), a;
};

var d = /*#__PURE__*/function (_t$Component) {
  _inherits(d, _t$Component);

  function d() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, d);

    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(d)).call.apply(_getPrototypeOf2, [this].concat(t))), e(_assertThisInitialized(_this), "_state_", {
      collapsibleElement: null,
      toggleState: _this.props.collapsed ? o.COLLAPSED : o.EXPANDED
    }), e(_assertThisInitialized(_this), "GET_HEIGHT", _this.props.offsetHeight ? "offsetHeight" : "scrollHeight"), e(_assertThisInitialized(_this), "state", {
      toggleState: _this._state_.toggleState,
      hasReversed: !1,
      range: _this.props.collapsed ? 0 : 1,
      progress: _this.props.collapsed ? 0 : 1
    }), e(_assertThisInitialized(_this), "getCollapsible", function () {
      return _this._state_.collapsibleElement;
    }), e(_assertThisInitialized(_this), "updateCollapsible", function (t, e) {
      _this.getCollapsible() && (_this._state_.collapsibleElement.style[t] = e);
    }), e(_assertThisInitialized(_this), "setCollapsibleElement", function (t) {
      _this._state_.collapsibleElement = t, _this._state_.collapsibleElement && !_this.props.noOverflowHidden && (_this._state_.collapsibleElement.style.overflow = "hidden"), _this._state_.toggleState === o.COLLAPSED && _this.setCollapsedState({
        initialState: !0
      });
    }), e(_assertThisInitialized(_this), "toggle", function () {
      if (_this.props.irreversible && h(_this._state_.toggleState)) return;

      var t = function t() {
        _this.props.onCollapsing && _this.props.onCollapsing({
          range: _this.state.range,
          progress: _this.state.progress,
          hasReversed: _this.state.hasReversed
        }), _this.collapse();
      },
          e = function e() {
        _this.props.onExpanding && _this.props.onExpanding({
          range: _this.state.range,
          progress: _this.state.progress,
          hasReversed: _this.state.hasReversed
        }), _this.expand();
      },
          s = function s(_ref3) {
        var t = _ref3.toggleState,
            e = _ref3.display,
            s = _ref3.hasReversed;
        _this._state_.toggleState = t, _this._state_.hasReversed = !!s, void 0 === e || _this.props.noDisplayStyle || _this.updateCollapsible("display", e);
        var a = p();

        if (s) {
          var _t = _this._state_.startTime,
              _e = n(_this.props.duration),
              _s = Math.min(_e, a - _t),
              _i = Math.max(0, _e - _s);

          _this._state_.startTime = a - _i;
        } else {
          var _e2 = _this.getCollapsible();

          _e2 && _e2.style.height && _this.updateCollapsible("height", null), _this._state_.boxHeight = _e2 ? _e2[_this.GET_HEIGHT] : 0, _this._state_.startTime = a, _this._state_.startDirection = t;
        }

        _this.setState({
          toggleState: _this._state_.toggleState,
          hasReversed: _this._state_.hasReversed
        });
      };

      switch (_this._state_.toggleState) {
        case o.EXPANDED:
          s({
            toggleState: o.COLLAPSING
          }), t();
          break;

        case o.COLLAPSED:
          s({
            toggleState: o.EXPANDING,
            display: ""
          }), e();
          break;

        case o.EXPANDING:
          s({
            toggleState: o.COLLAPSING,
            hasReversed: !0
          }), t();
          break;

        case o.COLLAPSING:
          s({
            toggleState: o.EXPANDING,
            display: "",
            hasReversed: !0
          }), e();
      }
    }), e(_assertThisInitialized(_this), "setExpandedState", function () {
      _this._state_.progress = 1, _this._state_.toggleState = o.EXPANDED, _this.updateCollapsible("height", null), _this.setState({
        toggleState: o.EXPANDED,
        range: 1,
        progress: _this._state_.progress
      }), _this.props.onExpanded && _this.props.onExpanded({
        hasReversed: _this.state.hasReversed
      });
    }), e(_assertThisInitialized(_this), "expand", function () {
      if (_this._state_.toggleState !== o.EXPANDING) return;
      var t = n(_this.props.duration);
      if (t <= 0) return void _this.setExpandedState();
      var e = _this._state_.startTime,
          s = Math.min(t, p() - e);
      if (s >= t) _this.setExpandedState();else {
        var _this$_state_ = _this._state_,
            _e3 = _this$_state_.startDirection,
            _a = _this$_state_.toggleState,
            _i2 = _this$_state_.boxHeight,
            _o = r({
          value: s / t
        });

        var _l;

        _l = _this.props.whenReversedUseBackwardEase && _e3 !== _a ? 1 - _this.props.easeCollapse(1 - _o) : _this.props.easeExpand(_o), _this.props.bestPerformance || _this.setState({
          range: _o,
          progress: _l
        }), _this.props.interpolateOnReverse && _this._state_.hasReversed && (_l = g({
          next: _l,
          prev: _this._state_.progress
        }));

        var _h = Math.round(_i2 * _l);

        _this._state_.progress = _l, _this.updateCollapsible("height", "".concat(_h, "px")), _this.nextTick(_this.expand);
      }
    }), e(_assertThisInitialized(_this), "setCollapsedState", function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          t = _ref4.initialState;

      _this._state_.progress = 0, _this._state_.toggleState = o.COLLAPSED, _this.props.noDisplayStyle ? _this.updateCollapsible("height", "0px") : (_this.updateCollapsible("display", "none"), _this.updateCollapsible("height", null)), _this.setState({
        toggleState: o.COLLAPSED,
        range: 0,
        progress: _this._state_.progress
      }), !t && _this.props.onCollapsed && _this.props.onCollapsed({
        hasReversed: _this.state.hasReversed
      });
    }), e(_assertThisInitialized(_this), "collapse", function () {
      if (_this._state_.toggleState !== o.COLLAPSING) return;
      var t = n(_this.props.duration);
      if (t <= 0) return void _this.setCollapsedState();
      var e = _this._state_.startTime,
          s = Math.min(t, p() - e);
      if (s >= t) _this.setCollapsedState();else {
        var _this$_state_2 = _this._state_,
            _e4 = _this$_state_2.startDirection,
            _a2 = _this$_state_2.boxHeight,
            _i3 = _this$_state_2.toggleState,
            _o2 = 1 - r({
          value: s / t
        }),
            _this$props = _this.props,
            _l2 = _this$props.whenReversedUseBackwardEase,
            _h2 = _this$props.easeExpand,
            _p = _this$props.easeCollapse;

        var _n;

        _n = _l2 && _e4 !== _i3 ? _h2(_o2) : 1 - _p(1 - _o2), _this.props.bestPerformance || _this.setState({
          range: _o2,
          progress: _n
        }), _this.props.interpolateOnReverse && _this._state_.hasReversed && (_n = g({
          next: _n,
          prev: _this._state_.progress
        }));

        var _d = Math.round(_a2 * _n);

        _this._state_.progress = _n, _this._state_.timeout = _this.nextTick(_this.collapse), _this.updateCollapsible("height", "".concat(_d, "px"));
      }
    }), e(_assertThisInitialized(_this), "nextTick", function (t) {
      _this._state_.timeout = a(t);
    });
    return _this;
  }

  _createClass(d, [{
    key: "render",
    value: function render() {
      var t = {
        onToggle: this.toggle,
        toggle: this.toggle,
        setCollapsibleElement: this.setCollapsibleElement,
        toggleState: this.state.toggleState,
        hasReversed: this.state.hasReversed,
        isMoving: h(this.state.toggleState),
        range: this.state.range,
        progress: this.state.progress
      };
      return "function" == typeof this.props.children ? this.props.children(t) : this.props.render ? this.props.render(t) : this.props.children;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount({
        toggleState: this.state.toggleState,
        toggle: this.toggle
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(t, e) {
      this.props.collapseEvent && this.props.collapseEvent > t.collapseEvent && (this._state_.toggleState !== o.EXPANDED && this._state_.toggleState !== o.EXPANDING || this.toggle()), this.props.expandEvent && this.props.expandEvent > t.expandEvent && (this._state_.toggleState !== o.COLLAPSED && this._state_.toggleState !== o.COLLAPSING || this.toggle()), this.props.toggleEvent && this.props.toggleEvent > t.toggleEvent && this.toggle();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.onUnmount && this.props.onUnmount({
        toggleState: this.state.toggleState
      }), this._state_.timeout && i(this._state_.timeout);
    }
  }]);

  return d;
}(t.Component);

e(d, "defaultProps", {
  duration: 300,
  easeCollapse: l,
  easeExpand: l
});
export default d;